import React from "react";
import { Heart, Rocket, Mail, BarChart } from "lucide-react";

const PricingSection = () => {
  const pricingPlans = [
    {
      name: "Free",
      icon: Heart,
      price: 0,
      description: "To grow referrals and leads of business looking",
      buttonText: "Get Started for Free",
      buttonStyle: "text-blue-500 bg-white border border-blue-500 hover:scale-105 transition-transform duration-300 ",
      features: [
        { text: "Data Sources: Up to 3 Accounts" },
        { text: "1 Workspace" },
        { text: "1 User" },
        { text: "Analytics Dashboard" },
        { text: "Google Add-on" },
        { text: "Reporting" },
      ],
    },
    {
      name: "Starter",
      icon: Rocket,
      price: 19,
      description: "To grow referrals and leads of business looking",
      buttonText: "Get Starter",
      buttonStyle: "text-white bg-blue-500 hover:bg-blue-600 hover:scale-105 transition-transform duration-300 ",
      isPopular: true,
      features: [
        { text: "Data Sources: Up to 10 Accounts" },
        { text: "1 Workspace" },
        { text: "1 User" },
        { text: "Analytics Dashboard" },
        { text: "Google Add-on" },
        { text: "Reporting" },
      ],
    },
    {
      name: "Professional",
      icon: Mail,
      price: 39,
      description: "To grow referrals and leads of business looking",
      buttonText: "Get Professional",
      buttonStyle: "text-blue-500 bg-white border border-blue-500 hover:scale-105 transition-transform duration-300 ",
      features: [
        { text: "Data Sources: Up to 3 Accounts" },
        { text: "1 Workspace" },
        { text: "1 User" },
        { text: "Analytics Dashboard" },
        { text: "Google Add-on" },
        { text: "Reporting" },
      ],
    },
    {
      name: "Team",
      icon: BarChart,
      price: 99,
      description: "To grow referrals and leads of business looking",
      buttonText: "Get Team",
      buttonStyle: "text-blue-500 bg-white border border-blue-500 hover:scale-105 transition-transform duration-300 ",
      features: [
        { text: "Data Sources: Up to 3 Accounts" },
        { text: "1 Workspace" },
        { text: "1 User" },
        { text: "Analytics Dashboard" },
        { text: "Google Add-on" },
        { text: "Reporting" },
      ],
    },
  ];
  const bg = [
    "bg-gradient-to-b from-[#F178781A] to-white",
    "bg-gradient-to-b from-[#E0EEFE] to-white ",
    "bg-gradient-to-b from-[#FFEFCC] to-white ",
    "bg-gradient-to-b from-[#EDE6FF] to-white ",
  ];
  const border = [
    "border-red-300",
    "border-blue-300",
    "border-yellow-300",
    "border-purple-300"
  ]
  return (
    <div className="max-w-[1200px] border-l border-r mx-auto px-4 py-16">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="flex items-center w-32 justify-center p-1 bg-gradient-to-b from-gray-100 to-white mx-auto mb-8 rounded-full">
          <div className="px-6 py-2 text-gray-600 font-medium bg-white border border-2 rounded-full geist-mono">
            Pricing
          </div>
        </div>
        <h2 className="text-4xl font-bold text-[#212f40] mb-8">
          Flexible Pricing, built for growth
        </h2>
        <div className="inline-flex items-center bg-[#F9FAFB] rounded-full p-1">
          <button className="px-6 py-2 font-semibold text-[#697586] rounded-md">
            Monthly
          </button>
          <button className="px-6 py-2 bg-white rounded-full shadow-sm shadow-lg flex items-center">
            <p className="text-[#1B91F0] font-semibold">Yearly</p>
            <span className="ml-2 text-xs bg-[#FDE3E3] p-2 rounded-full font-semibold text-[#E54545]">
              Save 20%
            </span>
          </button>
        </div>
      </div>

      {/* Pricing Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {pricingPlans.map((plan, index) => (
          <div
            key={plan.name}
            className={`relative rounded-2xl p-6 ${
              plan.isPopular ? "bg-gradient-to-b from-[#EDF4FF] to-white border-t-4 border-[#39A3F7]" : "bg-white"
            } border border-gray-200`}
          >
            {plan.isPopular && (
              <div className="absolute top-4 right-4 bg-blue-500 text-white text-xs px-3 py-1 rounded-full">
                Most Popular
              </div>
            )}

            <div
              className={`flex items-center justify-center w-16 h-16 rounded-full ${bg[index]}`}
            >
                <div className={`bg-white p-2 rounded-full ${border[index]}`}>
              <plan.icon
                className={`w-8 h-8 ${
                  index === 0
                    ? "text-red-500"
                    : index === 1
                    ? "text-blue-500"
                    : index === 2
                    ? "text-yellow-500"
                    : "text-purple-500"
                }`}
              />
              </div>
            </div>

            <h3 className="text-xl font-semibold mb-2">{plan.name}</h3>
            <p className="text-gray-500 text-sm mb-4">{plan.description}</p>

            <div className="mb-6">
              <span className="text-4xl font-bold">${plan.price}</span>
              <span className="text-gray-500">/month</span>
            </div>

            <button
              className={`w-full py-2 px-4 rounded-lg mb-6 ${plan.buttonStyle}`}
            >
              {plan.buttonText}
            </button>

            <div className="space-y-4">
              <div className="text-gray-600 font-medium">Features</div>
              {plan.features.map((feature, featureIndex) => (
                <div
                  key={featureIndex}
                  className="flex items-center text-gray-600"
                >
                  <svg
                    className={`w-5 h-5 mr-3 ${
                      index === 0
                        ? "text-red-500"
                        : index === 1
                        ? "text-blue-500"
                        : index === 2
                        ? "text-yellow-500"
                        : "text-purple-500"
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-sm">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingSection;
